import { Head, Link } from "@inertiajs/react";
import { Heading } from "@/components/ui/heading.jsx";
import { Button } from "@/components/ui/button.jsx";
import { CheckCircle2 } from "lucide-react";
import pageTitle from "@/utils/pageTitle.js";

export default function () {
  return (
    <>
      <Head title={pageTitle("Спасибо за обращение")} />
      <div className="container mx-auto px-4 py-24">
        <div className="max-w-lg mx-auto text-center">
          <div className="flex justify-center mb-6">
            <div className="rounded-full bg-success/10 p-4">
              <CheckCircle2 className="size-16 text-success" />
            </div>
          </div>

          <Heading size="h2" className="mb-4">
            Спасибо за обращение!
          </Heading>

          <p className="text-neutral-600 text-lg mb-8 leading-relaxed">
            Ваша заявка принята. Наш менеджер свяжется с вами в ближайшее время.
          </p>

          <Button asChild size="xl">
            <Link href="/">На главную</Link>
          </Button>
        </div>
      </div>
    </>
  );
}
